import React from "react";
import { Button } from "react-bootstrap";
import SelectDropdown from "../components-react/SelectDropdown";
import { gender } from "../common-data/DropdowData";
import { currentMonthCurrentDate } from "../common-data/Converts";
import CloseSubmitBtn from "../common-components/custom-comps/CloseSubmitBtn";

const FetchUserDetails = ({
  isUserExist,
  userFormData,
  setUserFormData,
  onClickFetchUserDetails,
  onClickRegisterUser,
  handleBack,
  isUpdateRequired,
  isDobOptional = false,
  isRegistering = false,
  isFetching = false,
}) => {
  return (
    <div className="paymentLinkForm userDetailsForm user-details-form-new-ui">
      <form
        className="formContainer"
        style={{
          paddingBottom: "0",
        }}>
        <div
          className="formInputsGrid fourGridSystem"
          style={{ alignItems: "center" }}>
          {isUserExist || isUpdateRequired ? (
            <>
              <div className="formInputBox">
                <label htmlFor="mobile" className="formInputLabel">
                  member Mobile Number <span className="required">*</span>
                </label>

                <input
                  type="number"
                  className="formInput"
                  name="number"
                  placeholder={`🚫 ${userFormData?.mobile || "NA"}`}
                  disabled
                />
              </div>

              <div className="formInputBox">
                <label htmlFor="name" className="formInputLabel">
                  member Name <span className="required">*</span>
                </label>

                <input
                  type="text"
                  className="formInput"
                  name="name"
                  placeholder="Enter Name"
                  value={userFormData.name}
                  onChange={(e) =>
                    setUserFormData({ ...userFormData, name: e.target.value })
                  }
                />
              </div>

              <div className="formInputBox">
                <label htmlFor="email" className="formInputLabel">
                  member Email <span className="required">*</span>
                </label>

                <input
                  type="email"
                  className="formInput"
                  style={{ textTransform: "lowercase" }}
                  name="email"
                  placeholder="Enter Email"
                  value={userFormData.email}
                  onChange={(e) =>
                    setUserFormData({ ...userFormData, email: e.target.value })
                  }
                />
              </div>

              <div className="formInputBox">
                <label htmlFor="gender" className="formInputLabel">
                  member gender <span className="required">*</span>
                </label>

                <div className="commonWrapper">
                  <SelectDropdown
                    options={gender.slice(0, -1)}
                    selectedOption={userFormData.gender}
                    setSelectedOption={(selectedValue) =>
                      setUserFormData({
                        ...userFormData,
                        gender: selectedValue,
                      })
                    }
                    name="gender"
                  />
                </div>
              </div>

              <div className="formInputBox">
                <label htmlFor="dob" className="formInputLabel">
                  member DOB {!isDobOptional && <span className="required">*</span>}
                </label>

                <input
                  type="date"
                  className={`formInput ${
                    userFormData.dob ? "date-has-value" : ""
                  }`}
                  name="dob"
                  value={userFormData.dob}
                  onChange={(e) =>
                    setUserFormData({ ...userFormData, dob: e.target.value })
                  }
                  max={currentMonthCurrentDate}
                />
              </div>

              {/* <div className="formButtons">
                <Button
                  className="saveBtn"
                  variant="danger"
                  onClick={() =>
                    onClickRegisterUser(isUpdateRequired ? true : false)
                  }>
                  {isUpdateRequired
                    ? "Update Member Details"
                    : "Register Member"}
                </Button>

                <Button
                  className="saveBtn smallText"
                  variant="dark"
                  onClick={handleBack}>
                  Back
                </Button>
              </div> */}
            </>
          ) : (
            <>
              <div className="formInputBox">
                <input
                  type="number"
                  className="formInput"
                  style={{ fontSize: "15px", letterSpacing: "2px" }}
                  name="number"
                  placeholder="Enter Mobile Number"
                  value={userFormData.mobile}
                  onChange={(e) => {
                    const mobileValue = e.target.value;

                    if (mobileValue.length <= 10) {
                      setUserFormData((prevs) => ({
                        ...prevs,
                        mobile: mobileValue,
                      }));
                    }
                  }}
                />
              </div>

              <div className="formButtons">
                <Button
                  className="saveBtn smallText"
                  variant="danger"
                  onClick={onClickFetchUserDetails}
                  disabled={isFetching}>
                  {isFetching ? "Fetching..." : "Fetch member Details"}
                </Button>
              </div>
            </>
          )}
        </div>

        {isUserExist || isUpdateRequired ? (
          <CloseSubmitBtn
            closeLabel="Back"
            submitLabel={
              isRegistering
                ? isUpdateRequired
                  ? "Updating..."
                  : "Registering..."
                : isUpdateRequired
                ? "Update Member Details"
                : "Register Member"
            }
            onClose={handleBack}
            onSubmit={() =>
              onClickRegisterUser(isUpdateRequired ? true : false)
            }
            isLoading={isRegistering}
          />
        ) : null}

        {/* <CloseSubmitBtn
          submitLabel={"Fetch Member Details"}
          onSubmit={onClickFetchUserDetails}
          isLoading={false}
        /> */}
      </form>
    </div>
  );
};

export default FetchUserDetails;
